import systemSlice from '../../redux/systemSlice';
import store from '../../redux/store';
import { translate } from '../../utils/language';
const errorCases = {
    401: "unauthorized",
    404: "notFound",
    418: "teapot",
    500: "internalServerError"
}

function requestErrorHandler(props: { response: { error: boolean; result: any; } }) {
    const { response } = props
    //@ts-ignore
    const errorMessage: any = response?.result?.data?.resultMessage
    const toastMessage = {
        detail: response?.result?.data?.resultDescription,
        summary: null
    }
    if (errorMessage) {
        toastMessage.summary = translate(errorMessage)
    }
    store.dispatch(systemSlice.actions.setToastError(toastMessage))
}

export default requestErrorHandler